/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as ApiSubmitCompanionRouteImport } from './routes/api/submit-companion'
import { Route as LangSupportRouteImport } from './routes/$lang.support'
import { Route as LangSubmitRouteImport } from './routes/$lang.submit'
import { Route as LangStoriesRouteImport } from './routes/$lang.stories'
import { Route as LangShopRouteImport } from './routes/$lang.shop'
import { Route as LangLegalRouteImport } from './routes/$lang.legal'
import { Route as LangLearnRouteImport } from './routes/$lang.learn'
import { Route as LangHelpRouteImport } from './routes/$lang.help'
import { Route as LangGlossaryRouteImport } from './routes/$lang.glossary'
import { Route as LangFaqRouteImport } from './routes/$lang.faq'
import { Route as LangContactRouteImport } from './routes/$lang.contact'
import { Route as LangCategoriesRouteImport } from './routes/$lang.categories'
import { Route as LangAboutRouteImport } from './routes/$lang.about'
import { Route as LangStoriesIndexRouteImport } from './routes/$lang.stories.index'
import { Route as LangStoriesSlugRouteImport } from './routes/$lang.stories.$slug'
import { Route as LangLearnSlugRouteImport } from './routes/$lang.learn.$slug'
import { Route as LangCategoriesSlugRouteImport } from './routes/$lang.categories.$slug'

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any)
const ApiSubmitCompanionRoute = ApiSubmitCompanionRouteImport.update({
  id: '/api/submit-companion',
  path: '/api/submit-companion',
  getParentRoute: () => rootRouteImport,
} as any)
const LangSupportRoute = LangSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => LangRoute,
} as any)
const LangSubmitRoute = LangSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => LangRoute,
} as any)
const LangStoriesRoute = LangStoriesRouteImport.update({
  id: '/stories',
  path: '/stories',
  getParentRoute: () => LangRoute,
} as any)
const LangShopRoute = LangShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => LangRoute,
} as any)
const LangLegalRoute = LangLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => LangRoute,
} as any)
const LangLearnRoute = LangLearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => LangRoute,
} as any)
const LangHelpRoute = LangHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => LangRoute,
} as any)
const LangGlossaryRoute = LangGlossaryRouteImport.update({
  id: '/glossary',
  path: '/glossary',
  getParentRoute: () => LangRoute,
} as any)
const LangFaqRoute = LangFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => LangRoute,
} as any)
const LangContactRoute = LangContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LangRoute,
} as any)
const LangCategoriesRoute = LangCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => LangRoute,
} as any)
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRoute,
} as any)
const LangStoriesIndexRoute = LangStoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangStoriesRoute,
} as any)
const LangStoriesSlugRoute = LangStoriesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => LangStoriesRoute,
} as any)
const LangLearnSlugRoute = LangLearnSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => LangLearnRoute,
} as any)
const LangCategoriesSlugRoute = LangCategoriesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => LangCategoriesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/admin': typeof AdminRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/categories': typeof LangCategoriesRouteWithChildren
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/glossary': typeof LangGlossaryRoute
  '/$lang/help': typeof LangHelpRoute
  '/$lang/learn': typeof LangLearnRouteWithChildren
  '/$lang/legal': typeof LangLegalRoute
  '/$lang/shop': typeof LangShopRoute
  '/$lang/stories': typeof LangStoriesRouteWithChildren
  '/$lang/submit': typeof LangSubmitRoute
  '/$lang/support': typeof LangSupportRoute
  '/api/submit-companion': typeof ApiSubmitCompanionRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/categories/$slug': typeof LangCategoriesSlugRoute
  '/$lang/learn/$slug': typeof LangLearnSlugRoute
  '/$lang/stories/$slug': typeof LangStoriesSlugRoute
  '/$lang/stories/': typeof LangStoriesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/categories': typeof LangCategoriesRouteWithChildren
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/glossary': typeof LangGlossaryRoute
  '/$lang/help': typeof LangHelpRoute
  '/$lang/learn': typeof LangLearnRouteWithChildren
  '/$lang/legal': typeof LangLegalRoute
  '/$lang/shop': typeof LangShopRoute
  '/$lang/submit': typeof LangSubmitRoute
  '/$lang/support': typeof LangSupportRoute
  '/api/submit-companion': typeof ApiSubmitCompanionRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/categories/$slug': typeof LangCategoriesSlugRoute
  '/$lang/learn/$slug': typeof LangLearnSlugRoute
  '/$lang/stories/$slug': typeof LangStoriesSlugRoute
  '/$lang/stories': typeof LangStoriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/admin': typeof AdminRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/categories': typeof LangCategoriesRouteWithChildren
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/glossary': typeof LangGlossaryRoute
  '/$lang/help': typeof LangHelpRoute
  '/$lang/learn': typeof LangLearnRouteWithChildren
  '/$lang/legal': typeof LangLegalRoute
  '/$lang/shop': typeof LangShopRoute
  '/$lang/stories': typeof LangStoriesRouteWithChildren
  '/$lang/submit': typeof LangSubmitRoute
  '/$lang/support': typeof LangSupportRoute
  '/api/submit-companion': typeof ApiSubmitCompanionRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/categories/$slug': typeof LangCategoriesSlugRoute
  '/$lang/learn/$slug': typeof LangLearnSlugRoute
  '/$lang/stories/$slug': typeof LangStoriesSlugRoute
  '/$lang/stories/': typeof LangStoriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/admin'
    | '/$lang/about'
    | '/$lang/categories'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/glossary'
    | '/$lang/help'
    | '/$lang/learn'
    | '/$lang/legal'
    | '/$lang/shop'
    | '/$lang/stories'
    | '/$lang/submit'
    | '/$lang/support'
    | '/api/submit-companion'
    | '/$lang/'
    | '/$lang/categories/$slug'
    | '/$lang/learn/$slug'
    | '/$lang/stories/$slug'
    | '/$lang/stories/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/$lang/about'
    | '/$lang/categories'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/glossary'
    | '/$lang/help'
    | '/$lang/learn'
    | '/$lang/legal'
    | '/$lang/shop'
    | '/$lang/submit'
    | '/$lang/support'
    | '/api/submit-companion'
    | '/$lang'
    | '/$lang/categories/$slug'
    | '/$lang/learn/$slug'
    | '/$lang/stories/$slug'
    | '/$lang/stories'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/admin'
    | '/$lang/about'
    | '/$lang/categories'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/glossary'
    | '/$lang/help'
    | '/$lang/learn'
    | '/$lang/legal'
    | '/$lang/shop'
    | '/$lang/stories'
    | '/$lang/submit'
    | '/$lang/support'
    | '/api/submit-companion'
    | '/$lang/'
    | '/$lang/categories/$slug'
    | '/$lang/learn/$slug'
    | '/$lang/stories/$slug'
    | '/$lang/stories/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRoute: typeof LangRouteWithChildren
  AdminRoute: typeof AdminRoute
  ApiSubmitCompanionRoute: typeof ApiSubmitCompanionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/api/submit-companion': {
      id: '/api/submit-companion'
      path: '/api/submit-companion'
      fullPath: '/api/submit-companion'
      preLoaderRoute: typeof ApiSubmitCompanionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/support': {
      id: '/$lang/support'
      path: '/support'
      fullPath: '/$lang/support'
      preLoaderRoute: typeof LangSupportRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/submit': {
      id: '/$lang/submit'
      path: '/submit'
      fullPath: '/$lang/submit'
      preLoaderRoute: typeof LangSubmitRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/stories': {
      id: '/$lang/stories'
      path: '/stories'
      fullPath: '/$lang/stories'
      preLoaderRoute: typeof LangStoriesRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/shop': {
      id: '/$lang/shop'
      path: '/shop'
      fullPath: '/$lang/shop'
      preLoaderRoute: typeof LangShopRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/legal': {
      id: '/$lang/legal'
      path: '/legal'
      fullPath: '/$lang/legal'
      preLoaderRoute: typeof LangLegalRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/learn': {
      id: '/$lang/learn'
      path: '/learn'
      fullPath: '/$lang/learn'
      preLoaderRoute: typeof LangLearnRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/help': {
      id: '/$lang/help'
      path: '/help'
      fullPath: '/$lang/help'
      preLoaderRoute: typeof LangHelpRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/glossary': {
      id: '/$lang/glossary'
      path: '/glossary'
      fullPath: '/$lang/glossary'
      preLoaderRoute: typeof LangGlossaryRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/faq': {
      id: '/$lang/faq'
      path: '/faq'
      fullPath: '/$lang/faq'
      preLoaderRoute: typeof LangFaqRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/contact': {
      id: '/$lang/contact'
      path: '/contact'
      fullPath: '/$lang/contact'
      preLoaderRoute: typeof LangContactRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/categories': {
      id: '/$lang/categories'
      path: '/categories'
      fullPath: '/$lang/categories'
      preLoaderRoute: typeof LangCategoriesRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/about': {
      id: '/$lang/about'
      path: '/about'
      fullPath: '/$lang/about'
      preLoaderRoute: typeof LangAboutRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/stories/': {
      id: '/$lang/stories/'
      path: '/'
      fullPath: '/$lang/stories/'
      preLoaderRoute: typeof LangStoriesIndexRouteImport
      parentRoute: typeof LangStoriesRoute
    }
    '/$lang/stories/$slug': {
      id: '/$lang/stories/$slug'
      path: '/$slug'
      fullPath: '/$lang/stories/$slug'
      preLoaderRoute: typeof LangStoriesSlugRouteImport
      parentRoute: typeof LangStoriesRoute
    }
    '/$lang/learn/$slug': {
      id: '/$lang/learn/$slug'
      path: '/$slug'
      fullPath: '/$lang/learn/$slug'
      preLoaderRoute: typeof LangLearnSlugRouteImport
      parentRoute: typeof LangLearnRoute
    }
    '/$lang/categories/$slug': {
      id: '/$lang/categories/$slug'
      path: '/$slug'
      fullPath: '/$lang/categories/$slug'
      preLoaderRoute: typeof LangCategoriesSlugRouteImport
      parentRoute: typeof LangCategoriesRoute
    }
  }
}

interface LangCategoriesRouteChildren {
  LangCategoriesSlugRoute: typeof LangCategoriesSlugRoute
}

const LangCategoriesRouteChildren: LangCategoriesRouteChildren = {
  LangCategoriesSlugRoute: LangCategoriesSlugRoute,
}

const LangCategoriesRouteWithChildren = LangCategoriesRoute._addFileChildren(
  LangCategoriesRouteChildren,
)

interface LangLearnRouteChildren {
  LangLearnSlugRoute: typeof LangLearnSlugRoute
}

const LangLearnRouteChildren: LangLearnRouteChildren = {
  LangLearnSlugRoute: LangLearnSlugRoute,
}

const LangLearnRouteWithChildren = LangLearnRoute._addFileChildren(
  LangLearnRouteChildren,
)

interface LangStoriesRouteChildren {
  LangStoriesSlugRoute: typeof LangStoriesSlugRoute
  LangStoriesIndexRoute: typeof LangStoriesIndexRoute
}

const LangStoriesRouteChildren: LangStoriesRouteChildren = {
  LangStoriesSlugRoute: LangStoriesSlugRoute,
  LangStoriesIndexRoute: LangStoriesIndexRoute,
}

const LangStoriesRouteWithChildren = LangStoriesRoute._addFileChildren(
  LangStoriesRouteChildren,
)

interface LangRouteChildren {
  LangAboutRoute: typeof LangAboutRoute
  LangCategoriesRoute: typeof LangCategoriesRouteWithChildren
  LangContactRoute: typeof LangContactRoute
  LangFaqRoute: typeof LangFaqRoute
  LangGlossaryRoute: typeof LangGlossaryRoute
  LangHelpRoute: typeof LangHelpRoute
  LangLearnRoute: typeof LangLearnRouteWithChildren
  LangLegalRoute: typeof LangLegalRoute
  LangShopRoute: typeof LangShopRoute
  LangStoriesRoute: typeof LangStoriesRouteWithChildren
  LangSubmitRoute: typeof LangSubmitRoute
  LangSupportRoute: typeof LangSupportRoute
  LangIndexRoute: typeof LangIndexRoute
}

const LangRouteChildren: LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,
  LangCategoriesRoute: LangCategoriesRouteWithChildren,
  LangContactRoute: LangContactRoute,
  LangFaqRoute: LangFaqRoute,
  LangGlossaryRoute: LangGlossaryRoute,
  LangHelpRoute: LangHelpRoute,
  LangLearnRoute: LangLearnRouteWithChildren,
  LangLegalRoute: LangLegalRoute,
  LangShopRoute: LangShopRoute,
  LangStoriesRoute: LangStoriesRouteWithChildren,
  LangSubmitRoute: LangSubmitRoute,
  LangSupportRoute: LangSupportRoute,
  LangIndexRoute: LangIndexRoute,
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
  AdminRoute: AdminRoute,
  ApiSubmitCompanionRoute: ApiSubmitCompanionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
